var map = {
	"./en/contact.json": 921,
	"./en/cookies.json": 5800,
	"./en/index.json": 9015,
	"./en/nav.json": 1570,
	"./en/offer.json": 900,
	"./en/policy.json": 7431,
	"./en/realisations.json": 3419,
	"./en/rodo.json": 875,
	"./en/team.json": 4796,
	"./pl/contact.json": 6315,
	"./pl/cookies.json": 1440,
	"./pl/index.json": 1712,
	"./pl/nav.json": 1295,
	"./pl/offer.json": 2512,
	"./pl/policy.json": 7581,
	"./pl/realisations.json": 8307,
	"./pl/rodo.json": 1220,
	"./pl/team.json": 1895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6376;